import React from "react";
import { Link } from "react-router-dom";
import { Headphones } from "lucide-react";
import { usePlayer } from "../context/PlayerContext";

const ListenFab = () => {
  const { current } = usePlayer();
  // hide when mini-player already shown (current is set)
  if (current) return null;
  return (
    <Link
      to="/music"
      className="fixed z-40 bottom-6 left-6 group hidden md:inline-flex items-center gap-2 pl-3 pr-5 py-2.5 rounded-full bg-black text-white text-sm font-medium shadow-xl border border-white/10 hover:scale-[1.03] transition-transform"
    >
      <span className="w-7 h-7 rounded-full bg-white text-black flex items-center justify-center">
        <Headphones className="w-4 h-4" />
      </span>
      Listen Now
    </Link>
  );
};

export default ListenFab;
